import React from 'react';
import { Link, graphql } from 'gatsby';

// import Bio from '../components/Bio';
import SEO from '../components/Seo';
import Layout from '../components/Layout';
import CustomMDXRenderer from '../components/mdx/CustomMDXRenderer';

import { H1 } from '../components/StyledComponents/TextStyles';

const BlogPostTemplate = ({ data, pageContext, location }) => {
	const post = data.mdx;
	const siteTitle = data.site.siteMetadata.title;
	const { previous, next } = pageContext;

	return (
		<Layout location={location} title={siteTitle}>
			<SEO
				title={post.frontmatter.title}
				description={post.frontmatter.description || post.excerpt}
			/>
			<article>
				<header className="mb-6" style={{ color: 'var(--color-secondary)' }}>
					<H1 customClass="mb-2">{post.frontmatter.title}</H1>
					<p
						className="date text-xs md:text-sm"
						style={{ color: 'var(--color-gray-600)' }}
					>
						{/* <DateFormater dateString={node.frontmatter.date} /> */}
						<time dateTime={new Date(post.frontmatter.date)}>
							{post.frontmatter.date}
						</time>
					</p>
				</header>
				<CustomMDXRenderer>{post.body}</CustomMDXRenderer>
				<hr />
				{/* <footer>
					<Bio />
				</footer> */}
			</article>

			{previous || next ? (
				<nav className="py-4">
					<ul className="flex flex-wrap justify-between p-0 list-none">
						<li>
							{previous && (
								<Link to={previous.fields.slug} rel="prev">
									← {previous.frontmatter.title}
								</Link>
							)}
						</li>
						<li>
							{next && (
								<Link to={next.fields.slug} rel="next">
									{next.frontmatter.title} →
								</Link>
							)}
						</li>
					</ul>
				</nav>
			) : null}
		</Layout>
	);
};

export default BlogPostTemplate;

export const pageQuery = graphql`
	query BlogPostBySlug($slug: String!) {
		site {
			siteMetadata {
				title
			}
		}
		mdx(fields: { slug: { eq: $slug } }) {
			id
			excerpt(pruneLength: 160)
			body
			frontmatter {
				title
				date(formatString: "MMMM DD, YYYY")
				description
				published
			}
		}
	}
`;
